import { PLAN_USAGE } from './planUsageDesignTokens'

/** @param {boolean} isOutline */
export function planUsageOutlineButtonSx(isOutline) {
  return {
    minWidth: 0,
    px: '8px',
    py: 0,
    height: isOutline ? 20 : 28,
    minHeight: isOutline ? 20 : 28,
    borderRadius: '6px',
    fontSize: '0.75rem',
    fontWeight: 590,
    lineHeight: '20px',
    letterSpacing: '-0.078px',
    color: '#11151A',
    textTransform: 'none',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    ...(isOutline ? { bgcolor: 'background.paper', border: `1px solid ${PLAN_USAGE.actionOutlineBorder}` } : { bgcolor: 'background.default', border: 'none' }),
  }
}
